<template>
  <div class="flex flex-col w-full">
    <div class="rounded-lg bg-WHITE flex flex-row p-3 gap-3 items-center w-full mt-2">
      <font-awesome-icon class="black-icon" icon="fa-solid fa-magnifying-glass" />
      <input
        v-model="message"
        placeholder="Search NFT"
        class="placeholder-[##8B8B8B] bg-WHITE border-0 focus:outline-none text-sm text-BLACK w-full"
      />
    </div>
    <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 md:grid-cols-5 gap-4 w-full mt-5">
      <nft-card @click="router.push({ name: 'CollectionPage' })" v-for="nft in tempNftData" :nft-data="nft">
        <div class="gap-1 flex flex-col items-start">
          <p class="font-semibold text-sm text-start">{{ nft.name }}</p>
          <div class="flex flex-row gap-2 justify-center items-center">
            <p class="text-xs text-GREY">Owned :</p>

            <p class="text-xs font-semibold">{{nft.owned}}/{{nft.allCount }}</p>
          </div>
        </div>
      </nft-card>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import NftCard from '../NftCard.vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const tempNftData = ref([
  {
    name: 'Factura by Ahmet',
    type: 'SSR',
    price: '100',
    owned: '2',
    allCount: '10'
  },
  {
    name: 'Aloha by Oğuz',
    type: 'R',
    price: '300',
    owned: '3',
    allCount: '12'
  },
  {
    name: 'Vice Captain',
    type: 'SR',
    price: '150',
    owned: '5',
    allCount: '25'
  }
])
</script>

<style scoped></style>
